module.exports = __webpack_public_path__ + "assets/7d583717ef3baa6f96a30d4bebaa430e.png";